jQuery_T4NT(document).ready(function($) {
  // category sidebar
  $('.cat_shop_wrap .widget_html li').click(function (e) {
    e.stopPropagation();
    $(this).next('ul').slideToggle();
    $(this).toggleClass('closed');
  });
  $('.cat_shop_wrap .widget_html li a').click(function (e) {
    e.stopPropagation(); 
  });
  $('.cat_shop_wrap .widget_html li').each(function () {
    if (!$(this).next().is('ul')) {
      $(this).addClass('no-children');
    }
  });
  
  setTimeout(function () {
    $('.cat_shop_wrap .widget_html li').click();
  }, 100);
});